import {QUESTION_SLOT_FALLBACK_CSS} from './questionSlotFallbackCss';

export const LIKERT_SCALE_SLOT_FALLBACK_CSS = `${QUESTION_SLOT_FALLBACK_CSS.replace(
    /data-incase-slot="question"/g,
    'data-incase-slot="likert-scale"'
)}
[data-incase-slot="likert-scale"] .c-likertScale {
  font: inherit;
  color: inherit;
}
[data-incase-slot="likert-scale"] .c-likertScale__gridContainer {
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  grid-template-columns: minmax(0, 2fr);
  align-items: center;
  gap: 0.75em;
}
[data-incase-slot="likert-scale"] .c-likertScale__scaleText {
  text-align: center;
  overflow-wrap: anywhere;
}
[data-incase-slot="likert-scale"] .c-likertScale__question {
  overflow-wrap: anywhere;
}
[data-incase-slot="likert-scale"] input[type="radio"] {
  justify-self: center;
  margin: 0;
  accent-color: currentColor;
  cursor: pointer;
}
[data-incase-slot="likert-scale"] input[type="radio"]:disabled {
  cursor: default;
}
[data-incase-slot="likert-scale"] .c-likertScale--mobile {
  display: flex;
  flex-direction: column;
  gap: 1em;
}
[data-incase-slot="likert-scale"] .c-likertScale__scale {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  margin-top: 0.5em;
}
[data-incase-slot="likert-scale"] .c-likertScale__scale_scaleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75em;
}
`;

export function injectLikertScaleSlotFallback(doc: Document): void {
    if (
        !doc.head ||
        !doc.querySelector('[data-incase-slot="likert-scale"]') ||
        doc.head.querySelector('style[data-incase-fallback="likert-scale"]')
    )
        return;

    const style = doc.createElement('style');
    style.setAttribute('data-incase-fallback', 'likert-scale');
    style.textContent = LIKERT_SCALE_SLOT_FALLBACK_CSS;
    doc.head.insertBefore(style, doc.head.firstChild);
}
